/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isNaN from 'lodash/isNaN';

import messages from 'aurora-translations';
import styles from './otpForm-jss';
import './otpForm.css';

const initialSec = 60;

function OtpForm(props) {
  const { classes, onSubmit, requestOTP, mobileNumber = '', pinId, isError, emailAuth, userEmail } = props;
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [isDisable, setDisable] = useState(true);
  const [seconds, setSeconds] = useState(initialSec);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const onResend = () => {
    setSeconds(initialSec);
    requestOTP(pinId);
  };

  useEffect(() => {
    // Handle to check if all the fields have the data
    const isFieldEmpty = otp.findIndex(field => isEmpty(field)) > -1;
    setDisable(isFieldEmpty);
  }, [otp]);
  const handleChange = (element, index) => {
    const { value, nextSibling, previousSibling } = element;
    if (isNaN(value) || value.length > 1) return;

    setOtp([...otp.map((d, idx) => (idx === index ? value : d))]);

    // Focus previous input
    if (value.length === 0 && previousSibling) {
      previousSibling.focus();
      return;
    }

    // Focus next input
    if (value.length > 0 && nextSibling) {
      nextSibling.focus();
    }
  };

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit && onSubmit(otp);
  };

  // eslint-disable-next-line
  String.prototype.replaceAt = function (index, replacement) {
    // eslint-disable-next-line
    return this.substring(0, index) + replacement + this.substring(index + replacement.length);
  };

  return (
    <>
      <Hidden smDown>
        <Typography variant='h5' component='h2' className={classes.Title}>
          <FormattedMessage {...messages.confirm_Otp} />
        </Typography>
      </Hidden>
      <p className={classes.subTitle}>
        {emailAuth ? (
          <FormattedMessage {...messages.otp_non_resident_message} />
        ) : (
          <FormattedMessage {...messages.otp_screen_message} />
        )}
      </p>
      <Typography
        variant='subtitle1'
        className='otpinputlabelRTL'
        classes={{
          root: classes.otpinputlabel,
        }}
      >
        {emailAuth ? userEmail.replaceAt(5, '***') || 'email***@gmail.com' : mobileNumber}
      </Typography>
      <form onSubmit={handleSubmit} noValidate autoComplete='off' className={classes.otpFrom}>
        <div className='otpFormControl'>
          <div className={classes.otpInputHolder}>
            {otp.map((value, index) => (
              <Box
                component='input'
                textAlign='center'
                id={`otp-${index}`}
                key={`otp-${index}`}
                type='number'
                placeholder='0'
                maxLength='1'
                value={value}
                className={classes.inputField}
                onChange={e => handleChange(e.target, index)}
                onFocus={e => e.target.select()}
                autoFocus={index === 0}
              />
            ))}
          </div>
        </div>
        {!isError && (
          <div className={classNames(classes.tryAgainContainer, classes.textSizeRaguler)}>
            <FormattedMessage {...messages.didnt_receive_code} />
            <Link
              disabled={seconds > 0}
              onClick={seconds <= 0 && onResend}
              className={classNames(
                classes.tryAgainText,
                classes.weightMedium,
                seconds > 0 ? classes.textDisabled : classes.textPrimary,
              )}
            >
              <FormattedMessage {...messages.try_again_in_secs} values={{ message: seconds > 0 ? `${seconds}` : '' }} />
            </Link>
          </div>
        )}

        {/* <div className={classes.warrningMessage}>
          <svg
            className={classes.infoSvg}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2.78158e-06 10C3.2644e-06 4.47715 4.47716 2.45765e-06 10 2.94047e-06C15.5228 3.42329e-06 20 4.47716 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 2.29875e-06 15.5228 2.78158e-06 10ZM9.99997 4.81481C9.38632 4.81481 8.88886 5.31227 8.88886 5.92592C8.88886 6.53957 9.38632 7.03703 9.99997 7.03703C10.6136 7.03703 11.1111 6.53957 11.1111 5.92592C11.1111 5.31227 10.6136 4.81481 9.99997 4.81481ZM11.1111 13.7037C11.1111 14.3148 10.6111 14.8148 10 14.8148C9.38889 14.8148 8.88889 14.3148 8.88889 13.7037L8.88889 9.25925C8.88889 8.64814 9.38889 8.14814 10 8.14814C10.6111 8.14814 11.1111 8.64814 11.1111 9.25925L11.1111 13.7037Z'
              fill='#096BCE'
            />
          </svg>
          <div className={classes.warrningtextHolder}>
            <strong>
              {emailAuth ? (
                <FormattedMessage {...messages.dont_have_access_to_this_email} />
              ) : (
                <FormattedMessage {...messages.otp_info_title} />
              )}
            </strong>
            <Box component='p' my={0.4}>
              {emailAuth ? (
                <FormattedMessage {...messages.please_contact_help_center_to_verify_your_identity} />
              ) : (
                <FormattedMessage {...messages.Please_visit_the_nearest_MOI} />
              )}
            </Box>
          </div>
        </div> */}

        <Button
          className={classNames(classes.btns, {
            [classes.infoBtn]: isDisable || isError,
            [classes.redBtn]: !isDisable && !isError,
          })}
          type='submit'
          size='large'
          fullWidth
          disabled={isDisable || isError}
        >
          <FormattedMessage {...messages.verify} />
        </Button>
      </form>

      <Box className={classes.fixedonmobile} mt={3} textAlign='center'>
        <a
          target='_blank'
          href='https://www.adgm.com/contact-us/make-enquiry'
          className={classNames(classes.weightMedium, classes.textPrimary, classes.textSizeRaguler)}
          rel='noreferrer'
        >
          <FormattedMessage {...messages.need_help_contact_us} />
        </a>
      </Box>
    </>
  );
}

OtpForm.propTypes = {
  classes: PropTypes.object.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  requestOTP: PropTypes.func.isRequired,
  pinId: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  userEmail: PropTypes.string,
  emailAuth: PropTypes.bool,
};

OtpForm.defaultProps = {
  emailAuth: false,
  userEmail: null,
};
export default withStyles(styles)(OtpForm);
